let scrollTimeout
export function useHeaderHook() {
    const isScrolling = ref(false)
    const opa = ref(0)
    const maxScroll = 300 // Adjust this value as needed
    const handleScroll = (e) => {
        const scrollPosition = e.target.scrollTop
        let opacity = scrollPosition / maxScroll
        opa.value = Math.min(opacity, 1) // Ensure opacity does
        opa.value = Math.max(opacity, 0) // 确保透明度不会低于 0
        isScrolling.value = true

        scrollTimeout && clearTimeout(scrollTimeout)

        scrollTimeout = setTimeout(function () {
            isScrolling.value = false
        }, 200)
    }

    return {
        handleScroll,
        opa,
        isScrolling,
    }
}
